import {filter} from 'rxjs/operators';
import {SERVICES} from '@px/const/services';
import {envUtil} from '@px/helper/env';
import {ty} from '@px/da/tingyun';
import {WebWorkerSubject} from '@px/observables/WebWorkerSubject';
import Msg = ww.Msg;

export const wwData$ = new WebWorkerSubject<Msg<any>>();

if (!envUtil.isBot) {
  const workerReady$ = wwData$.pipe(filter<Msg<any>>((o) => o.type === 'worker-ready'));
  workerReady$.subscribe(() => wwData$.next({type: 'ws-url', url: SERVICES.WS}));
}

// 接收 worker 中的听云事件
wwData$.pipe(filter<Msg<any>>((o) => o.type === 'tingyun-event')).subscribe(({data}) => ty.createEvent(data));
